import Eyebrow from './Eyebrow';
import Squiggle from './Squiggle';

interface Benefit {
  kicker: string;
  title: string;
  body: string;
  accent: 'yellow' | 'teal' | 'blue';
  pill?: string;
}

const BENEFITS: Benefit[] = [
  {
    kicker: '01',
    title: 'Test de positionnement offert (primaire)',
    body: "Sur simple demande après la JPO, nos enseignants évaluent votre enfant sur les fondamentaux et vous donnent un retour personnalisé. Sans engagement, sans pression. En maternelle : rencontre directe avec les enseignants de la section.",
    accent: 'yellow',
  },
  {
    kicker: '02',
    title: 'Une école, de 3 à 18 ans',
    body: "Maternelle, primaire, collège, lycée à Casablanca Oulfa. Votre enfant grandit dans le même environnement, avec les mêmes repères, jusqu'au baccalauréat.",
    accent: 'teal',
  },
  {
    kicker: '03',
    title: 'Lumi, le 1er tuteur IA marocain',
    body: "Un tuteur IA conçu par GSS qui accompagne nos élèves chaque soir sur leurs devoirs. Démos en direct samedi — venez voir Lumi en action.",
    accent: 'blue',
    pill: 'Exclusivité GSS',
  },
];

const Benefits = () => (
  <section className="benefits">
    <div className="container">
      <div className="benefits-head">
        <Eyebrow>Pourquoi venir samedi</Eyebrow>
        <h2 className="section-title">
          Trois bonnes raisons
          <br />
          <span className="section-title-emph">
            de bloquer votre samedi.
            <Squiggle className="title-squiggle" />
          </span>
        </h2>
      </div>

      <div className="benefits-grid">
        {BENEFITS.map((b) => (
          <article className={`benefit-card benefit-${b.accent}`} key={b.kicker}>
            <div className="benefit-kicker">{b.kicker}</div>
            <h3 className="benefit-title">{b.title}</h3>
            <p className="benefit-body">{b.body}</p>
            {b.pill && <span className="benefit-pill">{b.pill}</span>}
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
